export default __webpack_public_path__ + "locales/sr-Latn-RS/About.json?hash=14b437ce413f6def3e886bce30dddc5f";